(function ($) {
    $(function () {
        // If the URL contains a fragment identifier (hash), if the body element
        // does not have a LearnDash class, i.e. if the page is not a LearnDash
        // page, or if the window has already scrolled down, do not change the
        // scroll position.
        if (
            window.location.href.indexOf('#') !== -1 ||
            $('body').attr('class').indexOf('learndash') === -1 ||
            $(document).scrollTop() !== 0
        ) {
            return;
        }

        // Locate the page banner. Assume that everything after the banner is
        // the main content.
        var banner = $('.site_banner').first();

        if (banner.length === 0) {
            return;
        }

        // Scroll down to the main content.
        $('html, body').animate({
            scrollTop: banner.offset().top + banner.height()
        });
    });
})(jQuery);
